import type { CredentialResponse } from 'google-one-tap'
import { useVfm } from 'vue-final-modal'
import type { RewardModalProps } from '~/types/reward'
import { googleAuthCallback } from '~/utils/api'
import type { SignupReturnModal } from '~/composables/useSignupReturnTo'

// The callback of every Google sign-in (One Tap prompt, Google buttons): once
// signed in, the same post-login step as the login form (unread notifications,
// streak or sign-up reward, tracking). The streak is given once, in the first
// user fetch after signing in: skipping this step loses its reward modal.
// `returnModal`: the participation form the button sits in, opened again on
// the contest page once a new account has finalized its sign-up.
export const useGoogleSignIn = (
  openRewardModal: (data: RewardModalProps) => void,
  returnModal?: SignupReturnModal,
) => {
  const managePostLogin = useManagePostLogin((_, data) => openRewardModal(data))

  return async (response: CredentialResponse) => {
    const result = await googleAuthCallback(response)
    if (result === 'failed') return

    // a first Google sign-in is a sign-up in progress (sign_up once the completion form is sent), not a login
    if (result === 'temp') {
      useSignupReturnModal().value = returnModal
      return useVfm().closeAll()
    }

    track('login', {
      loginMethod: 'google',
    })

    return managePostLogin()
  }
}
